import ApiService from './apiService';

/**
 * Service for handling vehicle data from VIN code
 */
class VehicleDataService {
  /**
   * Fetches vehicle data by VIN code
   * @param {string} vin - Vehicle Identification Number (17 characters)
   * @param {string} modelType - Type of vehicle: 'personal' or 'utility' (required)
   * @returns {Promise<{success: boolean, data?: object, error?: string}>}
   */
  async fetchByVin(vin, modelType) {
    try {
      const { data } = await ApiService.get(
        `vehicle_data_from_vin/fetch_by_vin?vin=${vin}&model_type=${modelType}`
      );
      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nepodařilo se načíst data z VIN',
      };
    }
  }

  /**
   * Maps API response to AdvertisementStore format
   * Converts snake_case from API to camelCase for frontend
   * @param {object} vehicleData - Data from API
   * @returns {object} Mapped data with camelCase keys
   */
  mapVehicleDataToAdvertisement(vehicleData) {
    const mapping = {};

    if (vehicleData.brand) mapping.brand = vehicleData.brand;
    if (vehicleData.model) mapping.model = vehicleData.model;
    if (vehicleData.fuel) mapping.fuel = vehicleData.fuel;
    if (vehicleData.wheel_drive) mapping.wheelDrive = vehicleData.wheel_drive;
    if (vehicleData.seats_count) mapping.seatsCount = vehicleData.seats_count;
    if (vehicleData.country_origin) mapping.countryOrigin = vehicleData.country_origin;
    if (vehicleData.power) mapping.enginePower = vehicleData.power;
    if (vehicleData.displacement) mapping.displacement = vehicleData.displacement;
    if (vehicleData.rides_since_year) mapping.ridesSinceYear = vehicleData.rides_since_year;

    return mapping;
  }

  /**
   * Returns mapping between camelCase keys and store mutation names
   * @returns {object} Mapping of key -> mutation name
   */
  getMutationMapping() {
    return {
      brand: 'selectBrand',
      model: 'selectModel',
      fuel: 'selectFuel',
      wheelDrive: 'selectWheelDrive',
      seatsCount: 'selectSeatsCount',
      countryOrigin: 'selectCountryOrigin',
      enginePower: 'selectEnginePower',
      displacement: 'selectDisplacement',
      ridesSinceYear: 'selectRidesSinceYear',
    };
  }
}

export default new VehicleDataService();
